var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrosImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "decline",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #dc3545;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3704",
    "data-name": "Rectangle 3704",
    className: "cls-1",
    width: 21,
    height: 21
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_727",
    "data-name": "Mask Group 727",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25412",
    "data-name": "Path 25412",
    className: "cls-1",
    d: "M8.58,15.42a.58.58,0,0,0,.84,0L12,12.84l2.6,2.6a.523.523,0,0,0,.41.15.59.59,0,0,0,.41-.17.58.58,0,0,0,0-.84L12.84,12l2.6-2.6a.523.523,0,0,0,.15-.41.59.59,0,0,0-.17-.41.58.58,0,0,0-.84,0L12,11.16,9.4,8.56a.523.523,0,0,0-.41-.15.59.59,0,0,0-.41.17.58.58,0,0,0,0,.84L11.16,12l-2.6,2.6a.523.523,0,0,0-.15.41A.59.59,0,0,0,8.58,15.42ZM12,20a8.112,8.112,0,0,1-3.16-.61,7.743,7.743,0,0,1-4.23-4.23A8.112,8.112,0,0,1,4,12a8.059,8.059,0,0,1,.61-3.14A7.811,7.811,0,0,1,6.3,6.32,7.976,7.976,0,0,1,12,4a8.06,8.06,0,0,1,7.38,11.16,7.941,7.941,0,0,1-1.7,2.54,7.811,7.811,0,0,1-2.54,1.69A8.059,8.059,0,0,1,12,20Zm0-1.2a6.546,6.546,0,0,0,4.8-2,6.546,6.546,0,0,0,2-4.8,6.546,6.546,0,0,0-2-4.8,6.546,6.546,0,0,0-4.8-2,6.546,6.546,0,0,0-4.8,2,6.546,6.546,0,0,0-2,4.8,6.546,6.546,0,0,0,2,4.8A6.546,6.546,0,0,0,12,18.8Z",
    transform: "translate(-1 -1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrosImg);
export default __webpack_public_path__ + "static/media/crosImg.3952f5abb67b314d92f967e91cfc9996.svg";
export { ForwardRef as ReactComponent };